export default {
  ButtonName: {
    Close: 'Đóng',
    View: 'Xem',
    Setting: 'Thiết lập',
    Util: 'Tiện ích',
    Refresh: 'Nạp',
    CustomMoneyColumn: 'Tùy chọn trên các cột tiền',
    DefaultFormula: 'Lấy lại công thức mặc định',
    Save: 'Cất',
    Postpone: 'Hoãn'
  },
  ScreenName: {
    TitleName: 'Thiết lập báo cáo tài chính',
    Help: 'Trợ giúp',
    SetLayOut: 'Tùy chỉnh giao diện',
  },

};
